import { ElMessage } from 'element-plus'
import { authApi } from '../api'

export const auth = {
  // 用户登录
  async login(username, password) {
    try {
      const response = await authApi.login(username, password)
      
      if (response.success) {
        // 存储token和用户信息
        localStorage.setItem('auth_token', response.data.token)
        localStorage.setItem('user_info', JSON.stringify(response.data.user))
        
        ElMessage.success('登录成功')
        return response
      } else {
        ElMessage.error(response.message || '登录失败')
        throw new Error(response.message || '登录失败')
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message || '登录失败'
      ElMessage.error(message)
      throw error
    }
  },

  // 用户登出
  logout() {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user_info')
  },

  // 检查是否已登录
  isLoggedIn() {
    const token = localStorage.getItem('auth_token')
    const userInfo = localStorage.getItem('user_info')
    
    if (!token || !userInfo) {
      return false
    }
    
    // 检查token是否过期（24小时）
    try {
      const tokenData = JSON.parse(atob(token.split('.')[1]))
      const now = Math.floor(Date.now() / 1000)
      return tokenData.exp > now
    } catch (error) {
      this.logout()
      return false
    }
  },

  // 获取当前用户信息
  getCurrentUser() {
    if (!this.isLoggedIn()) {
      return null
    }
    
    try {
      return JSON.parse(localStorage.getItem('user_info'))
    } catch (error) {
      this.logout()
      return null
    }
  },

  // 获取token
  getToken() {
    if (!this.isLoggedIn()) {
      return null
    }
    
    return localStorage.getItem('auth_token')
  },

  // 验证token有效性
  async verifyToken() {
    try {
      const response = await authApi.verifyToken()
      return response.success
    } catch (error) {
      this.logout()
      return false
    }
  }
}
